import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XDiv, XImage, XText } from "IZOX/_X";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class Partner extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Partner.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderNormal(){
    return (
      <VStack mB={80} width={SysConfig.ContentWidth} pH={80}>
        <HStack HAlign="[" spacing={48}>
          <XText color={ColorX.CSS("Grass")} bold fontSize={32}>
            {LocaleX.Parse({
              EN: "Partner",
              TC: "合作夥伴"
            })}
          </XText>
          <XDiv pH={95} m={5} width={466} height={80}>
            <XImage source="/Images/home/bank.jpg" noResize />
          </XDiv>
        </HStack>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack mV={80} fullWidth pH={40}>
        <VStack HAlign="|" spacing={24}>
          <XText color={ColorX.CSS("Grass")} bold fontSize={36}>
            {LocaleX.Parse({
              EN: "Partner",
              TC: "合作夥伴"
            })}
          </XText>
          <XDiv p={20} m={30} width={window.innerWidth * 0.7}
            style={{boxShadow: `5px 5px 4px 4px ${ColorX.CSS("greyOut", 0.1)}`}}>
            <XImage source="/Images/home/bank.jpg" noResize />
          </XDiv>
        </VStack>
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }

}

export default observer(Partner);